<script setup lang="ts">

import { AppText } from '@shared/ui/typography'
import { ModalConfirmation } from '@shared/ui/modals'

import { useDisciplineModalMergeConfirm } from '../../model/discipline-modal-merge-confirm.hook'

defineOptions({
  name: 'ModalDisciplineMergeConfirm',
})

const {
  refIsOpen,
  refIsLoading,
  refTitle,
  refDetail,
  goBack,
  confirmMerge,
} = useDisciplineModalMergeConfirm()
</script>

<template>
  <ModalConfirmation
    :show="refIsOpen"
    :loading="refIsLoading"
    :disabled="refIsLoading"
    mode="info"
    :title="refTitle"
    cancel-title="Go back"
    :overlay-click="false"
    @click:confirm="confirmMerge"
    @click:cancel="goBack"
  >
    <template #content>
      <AppText
        name="body1"
        color="slate-700"
      >
        {{ refDetail }}
      </AppText>
    </template>
  </ModalConfirmation>
</template>
